import _slicedToArray from "/builds/1TgzPVrG/0/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useSpring, useSprings, config, SpringValue } from "react-spring";
import { size, colors } from "./../../shared/constants";
import { useWindowSize } from "./../../shared/hooks";
import { LeftCaret, RightCaret } from "./../Icons";
import * as S from "./styles";
import TabItem from "./TabItem";
var DEFAULT_COLORS = {
  containerBackground: colors.white,
  inactiveBackground: colors.white,
  inactiveBorderColor: colors.green4,
  inactiveTextColor: colors.green4,
  selectedBackground: colors.green4,
  selectedBorderColor: void 0,
  selectedTextColor: colors.white,
  arrowBackground: colors.white,
  arrowColor: colors.green5
};
export var TabMenu = function TabMenu(_ref) {
  var e = _ref.ariaLabel,
      t = _ref.ariaControls,
      _ref$initialActiveInd = _ref.initialActiveIndex,
      o = _ref$initialActiveInd === void 0 ? 0 : _ref$initialActiveInd,
      r = _ref.children,
      a = _ref.className,
      n = _ref.id,
      l = _ref.onItemSelect,
      _ref$isScrollable = _ref.isScrollable,
      i = _ref$isScrollable === void 0 ? !1 : _ref$isScrollable,
      _ref$isRound = _ref.isRound,
      c = _ref$isRound === void 0 ? !1 : _ref$isRound,
      _ref$hasArrows = _ref.hasArrows,
      s = _ref$hasArrows === void 0 ? !1 : _ref$hasArrows,
      _ref$scrollSpeed = _ref.scrollSpeed,
      u = _ref$scrollSpeed === void 0 ? 85 : _ref$scrollSpeed,
      _ref$addContainerPadd = _ref.addContainerPadding,
      d = _ref$addContainerPadd === void 0 ? !1 : _ref$addContainerPadd,
      _ref$fillAvailableSpa = _ref.fillAvailableSpace,
      f = _ref$fillAvailableSpa === void 0 ? !1 : _ref$fillAvailableSpa,
      v = _ref.colorConfig;

  var m = Object.assign(Object.assign({}, DEFAULT_COLORS), v),
      _useState = useState(o),
      _useState2 = _slicedToArray(_useState, 2),
      b = _useState2[0],
      g = _useState2[1],
      _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      p = _useState4[0],
      h = _useState4[1],
      _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      C = _useState6[0],
      L = _useState6[1],
      R = useRef(null),
      _useState7 = useState(!1),
      _useState8 = _slicedToArray(_useState7, 2),
      w = _useState8[0],
      k = _useState8[1],
      _useState9 = useState(!1),
      _useState10 = _slicedToArray(_useState9, 2),
      E = _useState10[0],
      T = _useState10[1],
      _useState11 = useState(0),
      _useState12 = _slicedToArray(_useState11, 2),
      y = _useState12[0],
      M = _useState12[1],
      _useState13 = useState(0),
      _useState14 = _slicedToArray(_useState13, 2),
      I = _useState14[0],
      W = _useState14[1],
      _useState15 = useState(!1),
      _useState16 = _slicedToArray(_useState15, 2),
      x = _useState16[0],
      B = _useState16[1],
      _useState17 = useState(!1),
      _useState18 = _slicedToArray(_useState17, 2),
      A = _useState18[0],
      O = _useState18[1],
      _useWindowSize = useWindowSize(),
      j = _useWindowSize.width,
      z = Number(size.xl3) / 2;

  useEffect(function () {
    var e = document.querySelector("[data-index=\"tab-menu-tab-".concat(o, "\"]"));
    e && (L(e.offsetWidth), h(e.offsetLeft), i && $(e));
  }, [o, i]), useLayoutEffect(function () {
    if (R.current) {
      var _R$current = R.current,
          _e = _R$current.scrollWidth,
          _t = _R$current.clientWidth;
      B(I - z > 0);
      O(!(_e - I - z <= _t));
    }
  }, [z, I, j]);

  var _useSpring = useSpring(function () {
    return {
      width: C,
      transform: "translateX(".concat(p, "px)"),
      config: Object.assign(Object.assign({}, config.stiff), {
        friction: 32,
        tension: 200
      })
    };
  }, [C, p, b]),
      _useSpring2 = _slicedToArray(_useSpring, 1),
      D = _useSpring2[0],
      N = React.Children.toArray(r),
      _useSprings = useSprings(React.Children.count(r), function () {
    return {
      opacity: 1
    };
  }),
      _useSprings2 = _slicedToArray(_useSprings, 2),
      U = _useSprings2[0],
      X = _useSprings2[1],
      F = function F() {
    X.start(function () {
      return {
        opacity: 1
      };
    });
  },
      P = function P(e) {
    X.start(function (t) {
      return e !== t ? {
        opacity: .5
      } : {
        opacity: 1
      };
    });
  },
      V = function V(e, t) {
    w || (t && (h(t.offsetLeft), L(t.offsetWidth), g(e), l(e), i && $(t)), F());
  },
      $ = function $(e) {
    setTimeout(function () {
      if (R.current) {
        var _t2 = R.current.clientWidth / 2,
            _o = e.clientWidth / 2,
            _r = e.offsetLeft;

        R.current.scrollLeft = _r + _o - _t2, W(R.current.scrollLeft);
      }
    });
  },
      _ = function _() {
    T(!1), setTimeout(function () {
      k(!1);
    });
  },
      q = function q(e) {
    var t;

    if (E && void 0 !== (null === (t = null == R ? void 0 : R.current) || void 0 === t ? void 0 : t.scrollLeft)) {
      e.preventDefault();

      var _t3 = e.clientX - R.current.offsetLeft - y;

      Math.abs(_t3) >= 3 && (k(!0), R.current.scrollLeft = I - _t3);
    }
  },
      G = function G(e) {
    var t;
    void 0 !== (null === (t = null == R ? void 0 : R.current) || void 0 === t ? void 0 : t.scrollLeft) && R.current.scrollBy({
      left: e,
      behavior: "smooth"
    });
  },
      H = function H(e, o) {
    var r = c || !o ? new SpringValue(1) : o;
    return React.createElement(TabItem, {
      ariaControls: t,
      handleClick: V,
      handleMouseEnter: P,
      handleMouseLeave: F,
      tabIndex: e,
      key: e,
      opacity: r,
      isScrollable: !!i,
      isScrolling: w,
      isRound: c,
      isSelected: b === e,
      colorConfig: m
    }, N[e]);
  };

  return React.createElement(S.TabContainer, {
    background: null == m ? void 0 : m.containerBackground
  }, s && x ? React.createElement(S.IconWrapper, {
    onClick: function onClick() {
      return G(-u);
    },
    "aria-controls": "tabMenu",
    role: "tab control",
    color: null == m ? void 0 : m.arrowColor,
    background: null == m ? void 0 : m.arrowBackground,
    isLeft: !0
  }, React.createElement(LeftCaret, null)) : null, React.createElement(S.TabItemsWrapper, {
    className: a,
    id: n,
    "data-testid": n,
    isScrollable: i,
    isRound: c,
    ref: R,
    onMouseDown: i ? function (e) {
      var t;
      T(!0), M(e.clientX - ((null === (t = R.current) || void 0 === t ? void 0 : t.offsetLeft) || 0));
    } : void 0,
    onMouseUp: i ? _ : void 0,
    onMouseLeave: i ? _ : void 0,
    onMouseMove: i ? q : void 0,
    onTouchMove: i ? q : void 0,
    onScroll: i ? function () {
      var e;
      void 0 !== (null === (e = null == R ? void 0 : R.current) || void 0 === e ? void 0 : e.scrollLeft) && W(R.current.scrollLeft);
    } : void 0
  }, React.createElement(S.Tabs, {
    "data-testid": "tab-menu-tabs",
    role: "tablist",
    "aria-label": e,
    fillAvailableSpace: f,
    addPadding: d
  }, c ? N.map(function (e, t) {
    return H(t);
  }) : U.map(function (_ref2, t) {
    var e = _ref2.opacity;
    return H(t, e);
  })), c ? null : React.createElement(S.AnimatedActiveIndicator, {
    style: D,
    background: null == m ? void 0 : m.inactiveTextColor
  })), s && A ? React.createElement(S.IconWrapper, {
    onClick: function onClick() {
      return G(u);
    },
    "aria-controls": "tabMenu",
    role: "tab control",
    color: null == m ? void 0 : m.arrowColor,
    background: null == m ? void 0 : m.arrowBackground
  }, React.createElement(RightCaret, null)) : null);
};
export default TabMenu;